export default "__VITE_ASSET__kEXaBHrf__"